
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBeaconMajorLateralRed as ObiSimplifiedBeaconMajorLateralRedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-beacon-major-lateral-red.js';
 
 
 

 
 export const ObiSimplifiedBeaconMajorLateralRed = createComponent({
   react: React,
   tagName: 'obi-simplified-beacon-major-lateral-red',
   elementClass: ObiSimplifiedBeaconMajorLateralRedElement,
   events: {
     
   }
  });
 
 